import { PowerPanelContentContainer } from '../components/powerPanelContentContainer';
import { PowerPanelHeaderContainer } from '../components/powerPanelHeaderContainer';
import { usePowerPanelContext } from '../contexts';
export var usePowerPanel = function (_a) {
    var _b = _a.panelBoxProps, panelBoxProps = _b === void 0 ? {} : _b, header = _a.header, _c = _a.headerContainer, headerContainer = _c === void 0 ? PowerPanelHeaderContainer : _c, content = _a.content, _d = _a.contentContainer, contentContainer = _d === void 0 ? PowerPanelContentContainer : _d, footer = _a.footer, _e = _a.dismissOnNav, dismissOnNav = _e === void 0 ? false : _e, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _f = _a.onClose, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose = _f === void 0 ? function () { } : _f, _g = _a.id, id = _g === void 0 ? null : _g;
    var _h = usePowerPanelContext(), setPanelBoxProps = _h.setPanelBoxProps, setHeader = _h.setHeader, setHeaderContainer = _h.setHeaderContainer, setContent = _h.setContent, setContentContainer = _h.setContentContainer, setFooter = _h.setFooter, setDismissOnNav = _h.setDismissOnNav, setOnClose = _h.setOnClose, setActiveId = _h.setActiveId, disclosure = _h.disclosure, activeId = _h.activeId, contextOnClose = _h.onClose;
    var open = function () {
        setPanelBoxProps(panelBoxProps);
        setHeader(header);
        setContent(content);
        setFooter(footer);
        setHeaderContainer(headerContainer);
        setContentContainer(contentContainer);
        setDismissOnNav(dismissOnNav);
        setActiveId(id);
        setOnClose(onClose);
        disclosure.onOpen();
    };
    var close = function () {
        contextOnClose();
    };
    var isActiveAndOpen = disclosure.isOpen && (!id || activeId === id);
    return {
        open: open,
        close: close,
        isOpen: disclosure.isOpen,
        isActiveAndOpen: isActiveAndOpen,
    };
};
